<template>
  <div>
    <div style="height: 54px" class="sub-nav-box-1">
      <!-- judul halaman -->
      <h2>Reimbursement</h2>
    </div>
    <!-- main view halaman -->
    <div style="margin-top: 70px; background: none" class="main-view">
      <RiwayatReimbursement />
    </div>
    <!-- end of main view halaman -->
  </div>
</template>

<script>
import RiwayatReimbursement from "@/components/reimbursement/RiwayatReimbursement";

export default {
  components: {
    RiwayatReimbursement,
  },
};
</script>

<style scoped>
@import url("../../assets/css/karyawan/reimbursement.css");
</style>
